import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import ResalesRequestService from '../../../services/resales-request';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faLink } from '@fortawesome/free-solid-svg-icons'
import {parseDateBR} from "helpers/date";

const LeadHistory = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1, elite: '' };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({data:[]});

  const [messageErro, setMessageErro] = useState(false);
  const Data = [];
  let Details = {};

  useEffect(() => {
    if(localStorage.getItem('companyId')!=null){
      let leads = ResalesRequestService.getResaleLeadHistory(localStorage.getItem('companyId'),{ params: { ...filters } });
      leads
      .then(data => {
        setReports(data.data);
      });
    } else {
      setMessageErro(true);
    }
  }, [filters]);


  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const columns = [
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'hubspot_id',
      text: 'ID Hubspot',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'deal_name',
      text: 'Nome do Negócio',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'updated_at',
      text: 'Data',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  function btn(id) {
    id = "btn-" + id;
    return <FontAwesomeIcon icon={faAngleRight} id={id}/>
  }

  const btn_move = id => {
    var btn = document.getElementById("btn-" + id);
    if (!btn.className.baseVal.includes("fa-rotate-90")) {
      btn.className.baseVal = btn.className.baseVal+"fa-rotate-90";
    } else {
      btn.className.baseVal = btn.className.baseVal.replace('fa-rotate-90', '');
    }
  }

  const renderData = () => {
    Object.values(reports.data).map((lead, k) => {
      Data.push({
        id: lead.id,
        btn:btn(lead.id),
        deal_name: lead.deal_name,
        hubspot_id: lead.hubspot_id,
        updated_at: parseDateBR(lead.updated_at)
      });
    });
  }
  renderData();

  const getDetails = rowId => {
    Object.values(reports.data).map(info => {
      if(rowId == info.id){
        var extend = info.extends;
        Details.name = extend.nome?extend.nome.name:'--';
        Details.email = extend.email?extend.email.email:'--';
        Details.phone = extend.phone?extend.phone.number:'--';
        Details.company = extend.company?extend.company.name:'--';
        Details.cnpj = extend.company?extend.company.document:'--';
        Details.date = info.deal_created_at?parseDateBR(info.deal_created_at):'--';
        Details.state = extend.anddress?extend.anddress.address_state:'--';
        Details.interesse = extend.interesse?extend.interesse.name:'--';
        Details.category = extend.category?extend.category.name:'--';
        Details.subcategory = extend.subcategory?extend.subcategory.sub_name:'--';
        Details.description = extend.description?extend.description.description:'--';
      }
    });
  };

  const expandRow = {
    renderer: row => (
      <>
        {getDetails(row.id)}
        {btn_move(row.id)}
        <Container>

        <Row>
          <Col className="col-3 p-2 border font-weight-bold">
            Nome
          </Col>
          <Col className="col-3 p-2 border">
          {Details.name}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
          Número de Telefone
          </Col>
          <Col className="col-3 p-2 border">
          {Details.phone}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            CNPJ
          </Col>
          <Col className="col-3 p-2 border">
            {Details.cnpj}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Marca de interesse
          </Col>
          <Col className="col-3 p-2 border">
            {Details.interesse}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Sub-Categoria
          </Col>
          <Col className="col-3 p-2 border">
            {Details.subcategory}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            E-mail
          </Col>
          <Col className="col-3 p-2 border">
            {Details.email}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Empresa
          </Col>
          <Col className="col-3 p-2 border">
            {Details.company}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Estado
          </Col>
          <Col className="col-3 p-2 border">
            {Details.state}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Data da cotação
          </Col>
          <Col className="col-3 p-2 border">
            {Details.date}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Solução
          </Col>
          <Col className="col-3 p-2 border">
            {Details.category}
          </Col>
          <Col className="col-3 p-2 border font-weight-bold">
            Descrição da Cotação
          </Col>
          <Col className="col-9 p-2 border">
            {Details.description}
          </Col>
          
        </Row>
        </Container>
      </>
    )
  };

  const listAttendance = ()=>{
    return (
        <>
          <Container fluid>
            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Row>
                      <Col xs={6} className="align-self-center">
                        <h4 className={styles.headerTitle}>
                          Histórico de Leads
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <hr className={styles.line} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={3}>
                        <Form.Group>
                          <Form.Label>Registros por página:</Form.Label>
                          <Form.Control
                            as="select"
                            value={filters.per_page}
                            onChange={e =>
                              handleFilterChange({ per_page: e.target.value })
                            }
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Form.Group>
                          <Form.Label>Pesquisa:</Form.Label>
                          <Form.Control
                            as="input"
                            //value={filters.per_page}
                            onChange={e => handleFilterChange({ search: e.target.value })}
                          >
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <BootstrapTable
                      id="table"
                      className="font-10"
                      keyField="id"
                      data={Data}
                      columns={columns}
                      noDataIndication={()=>{
                          return (<div className="text-xl-center font-12">Sem dados disponíveis na tabela</div>);
                      }}
                      expandRow={expandRow}
                    />
                    <Row>
                      <Col>
                        <Trans i18nKey="label:interpolateShowingRecords">
                          Showing {{ from: reports.from || '0' }} to{' '}
                          {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                          records
                        </Trans>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Pagination
                          activePage={reports.current_page}
                          itemsCountPerPage={reports.per_page}
                          totalItemsCount={reports.total}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          prevPageText="‹"
                          nextPageText="›"
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      );
  };

  const showMessageErro = ()=>{
    return (
      <>
        <Container fluid>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card className="card border border-dark text-center col-8">
                <Card.Body>
                  <Row>
                    <Col className="col-12 align-self-center p-5">
                      <h3 className="text-black mb-4 px-4">Você precisa selecionar uma revenda para visualizar os dados.</h3>
                      <a className="btn btn-primary btn-lg" href="./" role="button" onClick={()=>{
                        localStorage.setItem('returnPage',window.location.href);
                      }}>Selecionar Revenda</a>
                    </Col>
                  </Row>
                </Card.Body> 
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  };
return (<>{
    messageErro?showMessageErro():listAttendance()
    }</>);
};

export default MasterPage(LeadHistory);